import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const TestApi = createApi({
  reducerPath: "TestApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["TESTAPI"],
  endpoints: (build) => ({
    getTests: build.query({
      query: ({ page, search, limit, isAdminPanel, orgId, active , letter }) => ({
        url: `/tests?page=${page ?? ""}&search=${search ?? ""}&limit=${
          limit ?? ""
        }&isAdminPanel=${isAdminPanel}&orgId=${orgId ?? ""}&active=${
          active ?? ""
        }&letter=${letter ?? ""}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["TESTAPI"],
    }),

    getTestById: build.query({
      query: ({ id }) => ({
        url: `/tests/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["TESTAPI"],
    }),

    editTest: build.mutation({
      query: ({ id, data }) => ({
        url: `/tests/${id}`,
        method: "PATCH",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["TESTAPI"],
    }),

    addTest: build.mutation({
      query: ({ data }) => ({
        url: `/tests`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["TESTAPI"],
    }),
    bulkEditTestOfferPrice: build.mutation({
      query: ({ data }) => ({
        url: `/tests/bulk-offer-update`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["TESTAPI"],
    }),
    deleteTest: build.mutation({
      query: ({ id }) => ({
        url: `/tests/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["TESTAPI"],
    }),
  }),
});

export const {
  useGetTestsQuery,
  useGetTestByIdQuery,
  useEditTestMutation,
  useAddTestMutation,
  useDeleteTestMutation,
  useBulkEditTestOfferPriceMutation,
} = TestApi;
